import * as React from "react";
import { css } from "@emotion/react";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import { borderRadius } from "main/javascripts/styles/base/borderStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  minHeightStyle?: string;
  styleKey?: keyof IStyle;
  overflowStyle?: string;
  borderStyle?: string;
  marginStyle?: string;
}

export const Card: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const {
    children,
    minHeightStyle = "188px",
    styleKey = "card",
    overflowStyle = "hidden",
    borderStyle = "none",
    marginStyle,
    ...rest
  } = props;

  const cardStyles = css`
    ${cardStyle[styleKey]};
    min-height: ${minHeightStyle};
    overflow: ${overflowStyle};
    border: ${borderStyle};
    ${marginStyle && `margin: ${marginStyle};`}
  `;

  return (
    <div css={cardStyles} {...rest}>
      {children}
    </div>
  );
};

export interface IStyle {
  card: any;
  cardNoHover: any;
}

const cardBaseStyle = css`
  display: flex;
  flex-direction: column;
  min-height: 188px;
  overflow: hidden;
  position: relative;
  background: rgb(255, 255, 255);
  border-radius: ${borderRadius.normal};
  box-sizing: border-box;
  margin: ${space.atom2x} ${space.atom};
`;

export const cardStyle: IStyle = {
  card: css`
    ${cardBaseStyle};
    ${moreThanBreakpoint("tablet")} {
      flex-direction: row;
    },
  `,
  cardNoHover: css`
    ${cardBaseStyle};
    ${moreThanBreakpoint("tablet")} {
      flex-direction: row;
    }
  `,
};
